export default function AppVersion() {
    return (
        <span className="float-end me-3 font-monospace">
            v3.0.0
        </span>
    );
}